export default "/static/webpack/media/sum.69012a9b.svg";